"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOrderButtonLabel = void 0;
const DEFAULT_ORDER_BUTTON_LABEL = 'Enviar para {{resellerName}}';
const formatOrderButtonLabel = (resellerName) => DEFAULT_ORDER_BUTTON_LABEL.replace('{{resellerName}}', resellerName);
exports.formatOrderButtonLabel = formatOrderButtonLabel;
